import React from 'react';
import * as style from './mapRegion.module.scss';
import SelectableRegion from './selectableRegion';

const MapRegionSVG = props => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 957.65 600.03"
      className={style.regionsWrap}
      ref={props.getMapRef}
      preserveAspectRatio="xMidYMin slice"
    >
      {props.regionData.map((data, i) => (
        <SelectableRegion
          getRegionRef={props.getRegionRef}
          mini={props.mini}
          key={data.region_id}
          isLocating={!props.mini ? props.isLocating : false}
          handleSelect={props.handleSelect}
          handleDeselect={props.handleDeselect}
          index={i}
          selected={
            !props.mini
              ? i === props.regionSelected || i === props.regionHighlighted
              : data.region_id === props.hoverId
          }
          {...data.svgData}
        />
      ))}
    </svg>
  );
};

export default MapRegionSVG;
